// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryAd1-cls1_1kJ","cls2":"PodcastLibraryAd1-cls2_pvW PodcastLibraryAd1-cls1_1kJ"};